function mergePayload(state, options) {
  const { payload } = options;
  return { ...state, ...payload };
}

export default mergePayload;
